import { render, staticRenderFns } from "./dialog-comment.vue?vue&type=template&id=7b26c794"
import script from "./dialog-comment.vue?vue&type=script&lang=js"
export * from "./dialog-comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports